import {axiosPrivate} from "../axios-config/axiosPrivate";
import {standardRequestConfig} from "../axios-config/requestConfig";
import {BACKEND} from "../config/backend";
import {_getStandardReportDefinitions} from "./static/staticReportDefinition";
import {extractDataFromResponse} from "../store/saga-utils/httpInterceptorWrapper";
import {convertReportDefinitionToSchema, sortByCategoryAndName} from "../models/lists";

export const STUDIO_BASE_URL = `${BACKEND}/api/v1/studio`

export const convertTempImageKeyToUrl = (key) => {
    const encodedKey = encodeURIComponent(key)
    return `${STUDIO_BASE_URL}/tempimage?key=${encodedKey}`
}

export const addTempImage = ({image}) => {
    const data = {filename: image.name, dataUrl: image.dataURL}
    return axiosPrivate.post(`${STUDIO_BASE_URL}/tempimage`, data, {
        ...standardRequestConfig
    })
}

export const getFileById = ({fileId}) => {
    return axiosPrivate.get(`${STUDIO_BASE_URL}/files/${fileId}`, {
        ...standardRequestConfig
        , responseType: 'blob'
    })
}

export const getPads = () => {
    return axiosPrivate.get(`${STUDIO_BASE_URL}/pads`, {
        ...standardRequestConfig
    })
}

export const getNewPadSecret = ({padId}) => {
    return axiosPrivate.get(`${STUDIO_BASE_URL}/pads/${padId}/secret`, {
        ...standardRequestConfig
    })
}

export const getStudioReportDefinition = async ({reportDefID}) => {
    const data = extractDataFromResponse(await axiosPrivate.get(`${STUDIO_BASE_URL}/reportdefinitions/${reportDefID}`, {
        ...standardRequestConfig
    }))
    return convertReportDefinitionToSchema(data)

}

export const getAllStudioReportDefinitions = async () => {
   return extractDataFromResponse(await axiosPrivate.get(`${STUDIO_BASE_URL}/reportdefinitions`, {
        ...standardRequestConfig
    }))
}

export const getStandardReportDefinitions = (t) => _getStandardReportDefinitions(t).sort(sortByCategoryAndName)

export const insertStudioReportDefinition = ({reportDefinition}) => {
    return axiosPrivate.post(`${STUDIO_BASE_URL}/reportdefinitions`, reportDefinition, {
        ...standardRequestConfig
    })
}

export const insertStudioReportDefinitionList = ({reportDefinitionList}) => {
    return axiosPrivate.post(`${STUDIO_BASE_URL}/reportdefinitions`, reportDefinitionList, {
        ...standardRequestConfig
    })
}

export const updateStudioReportDefinition = ({reportDefinition}) => {
    return axiosPrivate.put(`${STUDIO_BASE_URL}/reportdefinitions/${reportDefinition.ReportDefID}`, reportDefinition, {
        ...standardRequestConfig
    })
}

export const deleteStudioReportDefinition = ({reportDefID}) => {
    return axiosPrivate.delete(`${STUDIO_BASE_URL}/reportdefinitions/${reportDefID}`, {
        ...standardRequestConfig
    })
}

export const deletePad = ({padId}) => {
    return axiosPrivate.delete(`${STUDIO_BASE_URL}/pads/${padId}`, {
        ...standardRequestConfig
    })
}

export const insertPad = ({pad}) => {
    return axiosPrivate.post(`${STUDIO_BASE_URL}/pads`, pad, {
        ...standardRequestConfig
    })
}

export const updateDocuVersandArtist = ({artistId}) => {
    return axiosPrivate.put(`${STUDIO_BASE_URL}/docuversand`, {DocuVersandArtist: artistId}, {
        ...standardRequestConfig
    })
}

export const getStudioSubscriptionStatus = () => {
    return axiosPrivate.get(`${BACKEND}/api/v1/studio/subscription/status`, {
        ...standardRequestConfig
    })
}

export const deleteLocation = ({tatortId}) => {
    return axiosPrivate.delete(`${STUDIO_BASE_URL}/locations/${tatortId}`, {
        ...standardRequestConfig
    })
}

export const updateStudioLocation = ({location}) => {
    return axiosPrivate.put(`${STUDIO_BASE_URL}/locations`, location, {
        ...standardRequestConfig
    })
}

export const insertStudioLocation = ({location}) => {
    return axiosPrivate.post(`${STUDIO_BASE_URL}/locations`, location, {
        ...standardRequestConfig
    })
}


